import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ReportEditorBody } from "./ReportEditorBody";

// PR-D: report editor. The primary detail surface for every generated report.
//
// The editor itself now lives in ReportEditorBody, which reads no routing hook
// and renders no <Link> — so the loan's Financial Reporting tab can mount the
// same surface in a drawer and B3 never leaves the loan to read the report it
// just generated. This wrapper is the ROUTE: it owns `useParams` and the back
// link, and nothing else. (ListingDetailBody / SubmissionDetailBody set the
// pattern; both are pinned by a test that renders the body with no Router.)
//
// Stage transitions are still recorded in the database (Generate -> Drafted,
// Finalize & Download -> BrandingApplied + Finalized atomically) but are not
// exposed in the UI per the redesign.

export function ReportEditorPage() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="max-w-5xl">
      <Link
        to="/reports"
        className="inline-flex items-center gap-space-1 text-caption text-gray-mid hover:text-onyx"
      >
        <ArrowLeft size={14} aria-hidden /> Reports
      </Link>
      <div className="mt-space-2">
        <ReportEditorBody reportId={id ?? ""} />
      </div>
    </div>
  );
}
